import PickTourFooter from './PickTourFooter';

export default PickTourFooter;
